import {
  GLEmptyList,
  GLList,
  GLPaginationComponent,
} from "@group-link-one/grouplink-components";

import EmptyListImage from "../../../../images/MessageCenter/empty_art_light.svg";
import { ApresentationNotificationsCards } from "../Cards/ApresentationNotificationsCards";
// import { useListNotifications } from "../../../../Services/messageCenterService/useListNotifications";
import { NotificationsContentContainer } from "./NotificationsContentStyle";
import { IPP_NOTIFICATIONS, useNotificationsContent } from "./useNotificationsContent";

export function NotificationsContent() {
  const {
    tabs,
    activeTab,
    currentPage,
    handleOnPaginate,
    notificationsDelivereds,
    notificationsDeliveredsIsLoading
  } = useNotificationsContent();

  return (
    <NotificationsContentContainer>
      {notificationsDelivereds && notificationsDelivereds.length === 0 ? (
        <div className="online-campaign-empty-list">
          <GLEmptyList
            title="No notifications delivered yet"
            description="When you send a notification, it will appear here."
            icon={<img src={EmptyListImage} alt="" />}
            hasBorder={true}
          />
        </div>
      ) : (
        <GLList
          listName="Notifications"
          isLoading={notificationsDeliveredsIsLoading}
          content={
            <ApresentationNotificationsCards notifications={notificationsDelivereds} />
          }
          tabActive={activeTab?.name || ""}
          tabs={tabs}
          filters={
            <GLPaginationComponent
              itemsPerPage={IPP_NOTIFICATIONS}
              nextPage={handleOnPaginate}
              previousPage={handleOnPaginate}
              totalItems={tabs[0].count || 0}
              currentPage={currentPage}
            />
          }
        />
      )}

    </NotificationsContentContainer>
  );
}
